export default {
    "delete-message-mission": "Are you sure you want to delete this task?"
}